<template>
    <div class="chapter_styling" ref="content" v-html="modifiedContent"></div>
</template>

<script>
export default {
    emits: ["text-highlighted"],
    data: function(){
        return {
          modifiedContent: ''
        }
    },
    props: {
        sectionId:{
            required: true,
            type: Number
        },
        content: {
            required: true,
            type: String
        },
      /**
       * @type {Array<ContentModifier>}
       */
      contentModifiers: {
        type: Array,
        required: true
      }
    },
    methods: {},
    created() {
      this.modifiedContent = this.content;
      this.contentModifiers.forEach(modifier => {
        this.modifiedContent = (modifier.modifyPreRender(this.modifiedContent) ?? this.modifiedContent);
      });
    },
    mounted() {
      this.$nextTick(() => {
        this.contentModifiers.forEach(modifier => {
          const contentElement = this.$refs.content;
          modifier.modifyPostRender(contentElement, this.sectionId);
        });
      });
    }
}
</script>

<style scoped lang="scss">

</style>